/**
 * Read-only state provided by AccessBlock (ADR 0006 D4) for controls that ignore the disabled
 * fieldset. Outside AccessBlock the component stays editable.
 */
export const AccessBlockMixin = {
  inject: {
    accessBlock: { default: () => ({ isReadOnly: false }) },
  },
  computed: {
    isBlockReadOnly() {
      return this.accessBlock.isReadOnly;
    },
  },
};
